/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="18.82"
        height="17.4"
        viewBox="0 0 18.82 17.4"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M18.82 6.66 9.5.06 9.41 0 .12 6.58 0 6.67l.58.81 1.55-1.09v11h5.53v-6.3h3.53v6.3h5.52v-11l1.56 1.1Zm-3.14 9.73h-3.49v-6.3h-5.5v6.3H3.16V5.67l6.28-4.45 6.28 4.45Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'HouseIcon';

export default Icon;
